export const PartnerPositions = {
    positions: {
        shareholder: 'REPRESENTATIVE',
        owner: 'OWNER', 
        both: 'BOTH'
    }
}
